import { Component } from "react"

class InstagramId extends Component{
    constructor(props){
        super(props)
        this.name = "Instagram ID"
    }
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(String(this.props).trim().length > 0){
            if(this.props.length > 100){
                callbackDialog("エラー",this.name + "は100文字以内にしてください。")
                return false
            }
            if(!/^[\w.]+$/.test(this.props)){
                callbackDialog("エラー",this.name + "の形式ではありません。")
                return false
            }
        }
        return true
    }
}

export default InstagramId;